import config from "../config"

let facebookReady: Promise<void> | null = null
let googlePlatformReady: Promise<void> | null = null

export function ensureFacebookSDK(): Promise<void> {
  if (typeof window === "undefined") return Promise.resolve()
  // @ts-ignore
  if (window.FB) return Promise.resolve()
  if (facebookReady) return facebookReady

  facebookReady = new Promise((resolve, reject) => {
    // @ts-ignore
    window.fbAsyncInit = function () {
      // @ts-ignore
      window.FB.init({
        appId: config.GATSBY_FACEBOOK_APP_ID,
        cookie: true,
        xfbml: true,
        version: "v10.0",
        scope: "email",
      })
      resolve()
    }
    const script = document.createElement("script")
    script.async = true
    script.defer = true
    script.crossOrigin = "anonymous"
    script.src = "https://connect.facebook.net/en_US/sdk.js#version=v10.0"
    script.onerror = () => reject(new Error("Facebook SDK failed to load"))
    document.head.appendChild(script)
  })
  return facebookReady
}

export function ensureGoogleSignInPlatform(): Promise<void> {
  if (typeof window === "undefined") return Promise.resolve()
  // @ts-ignore
  if (window.gapi) return Promise.resolve()
  if (googlePlatformReady) return googlePlatformReady

  if (
    !document.querySelector('meta[name="google-signin-client_id"]') &&
    config.GATSBY_GOOGLE_CLIENT_ID
  ) {
    const meta = document.createElement("meta")
    meta.name = "google-signin-client_id"
    meta.content = config.GATSBY_GOOGLE_CLIENT_ID
    document.head.appendChild(meta)
  }

  googlePlatformReady = new Promise((resolve, reject) => {
    const script = document.createElement("script")
    script.async = true
    script.defer = true
    script.src = "https://apis.google.com/js/platform.js"
    script.onload = () => resolve()
    script.onerror = () => reject(new Error("Google platform.js failed to load"))
    document.head.appendChild(script)
  })
  return googlePlatformReady
}
